import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './aerial-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class AerialDetailComponent extends AbstractCollectionDirective {}
